<template>
  <div>
    <Header />
    <AttendanceView/>
  </div>
</template>

<script>
import Header from "@/components/Mentor/Header.vue";
import AttendanceView from "@/views/Attendance/AttendanceView.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    Header,
    AttendanceView
  },
  computed: mapGetters(["userInfo"]),
};
</script>

<style></style>
